<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <div>
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              {{planObj.heading1}}
            </div>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <DatePicker :date= "{
                obj: 'stats.dcrt',
                label: dateTypeA(this.getDetailStats.dcrt),
                hint: 'created',
                icon: 'edit_calendar'
                }"
              />
            </v-flex>
            <v-flex xs12 md8 lg6>
              <DatePicker :date= "{
                obj: 'stats.drev',
                label: dateTypeA(this.getDetailStats.drev),
                hint: 'review',
                icon: 'event_note'
                }"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <DatePicker :date= "{
                obj: 'stats.dstr',
                label: dateTypeA(this.getDetailStats.dstr),
                hint: 'plan start',
                icon: 'today'
                }"
              />
            </v-flex>
            <v-flex xs12 md8 lg6>
              <DatePicker :date= "{
                obj: 'stats.dend',
                label: dateTypeA(this.getDetailStats.dend),
                hint: 'plan end',
                icon: 'event'
                }"
              />
            </v-flex>
          </v-layout>
        </div>
        <div>
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              {{planObj.heading2}}
            </div>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.coste"
              :rules="ruleNumberPositive"
              prepend-icon="attach_money"
              hint="estimate"
              :suffix="localForm.costu"
              persistent-hint
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md8 lg6>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.costa"
              :rules="ruleNumberPositive"
              prepend-icon="attach_money"
              hint="actual"
              :suffix="localForm.costu"
              persistent-hint
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.carbe"
              :rules="ruleNumberPositive"
              prepend-icon="co2"
              hint="estimate"
              :suffix="localForm.carbu"
              persistent-hint
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md8 lg6>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.carba"
              :rules="ruleNumberPositive"
              prepend-icon="co2"
              hint="actual"
              :suffix="localForm.carbu"
              persistent-hint
              ></v-text-field>
            </v-flex>
          </v-layout>
        </div>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import DatePicker from "@/data/functions/components/DatePicker";
import businessOptions from "@/data/options/mixins/businessOptions.js";

import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true,
      localForm: {
        coste: "",
        carbe: "",
        costa: "",
        carba: "",
        costu: "",
        carbu: ""
      },
      orgForm: {
        coste: "",
        carbe: "",
        costa: "",
        carba: "",
        costu: "",
        carbu: ""
      }
    };
  },
  // eslint-costaable-next-line
  mixins: [
    docRevsModFunctions,
    ruleTextfield,
    apptheme,
    dateFunctions,
    businessOptions
  ],
  beforeMount() {
    // fix orginal data before change
    this.localForm.costa = this.getDetail.char.costa;
    this.localForm.carba = this.getDetail.char.carba;
    this.localForm.coste = this.getDetail.char.coste;
    this.localForm.carbe = this.getDetail.char.carbe;
    this.localForm.carbu = this.getDetail.char.carbu;
    this.localForm.costu = this.getDetail.char.costu;

    this.orgForm.costa = this.getDetail.char.costa;
    this.orgForm.carba = this.getDetail.char.carba;
    this.orgForm.coste = this.getDetail.char.coste;
    this.orgForm.carbe = this.getDetail.char.carbe;
    this.orgForm.carbu = this.getDetail.char.carbu;
    this.orgForm.costu = this.getDetail.char.costu;
  },
  computed: {
    ...mapGetters([
      "getDetail",
      "getDetailBasic",
      "getDetailChar",
      "getDetailStats",
      "getCurrentPage"
    ]),
    planObj() {
      let obj = {
        heading1: "Plan",
        heading2: "Estimate"
      };
      if (this.getDetailBasic.tag === "B4") {
        obj.heading1 = "Budget Plan";
        obj.heading2 = "Budget Estimate";
      }
      if (this.getDetailBasic.tag === "E2") {
        obj.heading1 = "Project Plan";
        obj.heading2 = "Project Budget";
      }
      return obj;
    }
  },
  components: {
    DatePicker
  },
  methods: {
    updateFormChar() {
      let char = this.getDetailChar;
      // eslint-costaable-next-line
      if (
        this.localForm.costa !== this.orgForm.costa &&
        this.localForm.costa !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.costa = this.localForm.costa;
        // basic
        char.costa = this.localForm.costa;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.coste !== this.orgForm.coste &&
        this.localForm.coste !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.coste = this.localForm.coste;
        // basic
        char.coste = this.localForm.coste;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 2); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.carbe !== this.orgForm.carbe &&
        this.localForm.carbe !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.carbe = this.localForm.carbe;
        // basic
        char.carbe = this.localForm.carbe;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 3); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.carba !== this.orgForm.carba &&
        this.localForm.carba !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.carba = this.localForm.carba;
        // basic
        char.carba = this.localForm.carba;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 5); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
    }
  }
};
</script>
